

const endPoint = {
    login:"api/login",
    marques:"api/marques",
    models:"api/models",
    annees:"api/annees",
    categories:"api/categories",
    pays:"api/pays",
    vehicules:"api/vehicules",
    vehiculesEnVente:"api/vehicules-en-vente",
    vehiculesEnLocation:"api/vehicules-en-location",
    commandes:"api/commandes",
    publicites:"api/publicites",
    users:"api/users",


    produits:"api/produits",
    promotions:"promotions",
    livreurs:"livreurs",
    fournisseurs:"fournisseurs",
    clients:"clients",
    administrateurs:"administrateurs",
}

export default endPoint